import {
  type MicroLabCurrentUser,
  type MicroLabCurrentUserRoleKey,
  readMicroLabCurrentUserApplicationRoles,
} from "./lib/micro-lab-auth-api";

const MICRO_LAB_ADMIN_ROLES = new Set<MicroLabCurrentUserRoleKey>([
  "teacher",
  "platform_manager",
]);

const MICRO_LAB_TEACHER_WORKSPACE_ROLES = new Set<MicroLabCurrentUserRoleKey>([
  "teacher",
  "platform_manager",
]);

const MICRO_LAB_MEMBER_MANAGEMENT_ROLES = new Set<MicroLabCurrentUserRoleKey>([
  "platform_manager",
]);

const MICRO_LAB_LIBRARY_REVIEW_ROLES = new Set<MicroLabCurrentUserRoleKey>([
  "platform_manager",
]);

type InitialState = {
  currentUser?: MicroLabCurrentUser | null;
  microLabUser?: MicroLabCurrentUser | null;
};

function resolveApplicationRoles(
  microLabUser: MicroLabCurrentUser | null | undefined,
) {
  if (!microLabUser) return [];
  return readMicroLabCurrentUserApplicationRoles(microLabUser);
}

function hasApplicationRole(
  user: MicroLabCurrentUser | null | undefined,
  expectedRoles: ReadonlySet<MicroLabCurrentUserRoleKey>,
) {
  if (!user) return false;
  return resolveApplicationRoles(user).some((role) => expectedRoles.has(role));
}

export function canAccessMicroLabTeacherWorkspace(user: MicroLabCurrentUser | null | undefined) {
  return hasApplicationRole(user, MICRO_LAB_TEACHER_WORKSPACE_ROLES);
}

export default function access(initialState: InitialState | undefined) {
  const currentUser = initialState?.currentUser ?? null;
  const microLabUser = initialState?.microLabUser ?? null;
  const hasBusinessUser = Boolean(currentUser && microLabUser);
  return {
    canAccessMicroLabAdmin: hasBusinessUser && hasApplicationRole(microLabUser, MICRO_LAB_ADMIN_ROLES),
    canManageMicroLabMembers: hasBusinessUser && hasApplicationRole(microLabUser, MICRO_LAB_MEMBER_MANAGEMENT_ROLES),
    canReviewMicroLabLibrary: hasBusinessUser && hasApplicationRole(microLabUser, MICRO_LAB_LIBRARY_REVIEW_ROLES),
    canAccessMicroLabTeacherWorkspace: hasBusinessUser && canAccessMicroLabTeacherWorkspace(microLabUser),
  };
}
